import { ChangeDetectorRef, Injectable } from "@angular/core";
import { Schedule, Vacancy } from "../../core/models";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmModalComponent } from "../modal/confirm-modal/confirm-modal.component";
import { CreateEventComponent } from "../modal/create-event/create-event.component";

@Injectable()
export class ScheduleService {

  constructor(private modalService: NgbModal) { }

  async validateSchedule(schedules: Schedule[], scheduleId: string): Promise<boolean> {
    const schedule = schedules.find(schedule => schedule._id === scheduleId);
    const isEventDatFeasible = this.isEventDateFeasible(schedule);
    if (!isEventDatFeasible) {
      const result = await this.openModalWarning('Atenção!', 'A data do evento está muito próxima. Deseja continuar mesmo assim?');
      return result;
    }
    return true;
  }

  isEventDateFeasible(schedule: Schedule): boolean {
    const eventStartTime = schedule.start;
    const diffTime = moment(eventStartTime).diff(moment(), "hours");
    return diffTime > 48;
  }

  async openModalWarning(title: string, message: string) {
    const modal = this.modalService.open(ConfirmModalComponent, { size: 'lg' });
    modal.componentInstance.htmlTitle = title;
    modal.componentInstance.htmlMessage = message;
    return modal.result
  }

  openModalScheduling(vacancy: Vacancy, vacancyId: string, ref: ChangeDetectorRef, funcGetVacancyAllData: Function): Promise<string | null> {
    return new Promise((resolve) => {
      // remove o foco no select, para corrigir erro de detecção do mat-select
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      setTimeout(() => {
        let steps = vacancy.process.steps;
        steps = steps.filter(step => step.key === 'scheduling');

        if (steps && steps.length > 0) {
          const modal = this.modalService.open(CreateEventComponent, { backdrop: 'static', keyboard: false, size: 'lg' });

          modal.componentInstance.steps = steps;
          modal.componentInstance.vacancyName = vacancy.office;
          modal.componentInstance.vacancyId = vacancyId;

          modal.result.then(res => {
            if (typeof funcGetVacancyAllData === 'function') {
              funcGetVacancyAllData();
            }

            resolve(res._id);
          }).catch(() => resolve(null));

        } else {
          resolve(null);
        }

        ref.markForCheck();
      }, 10)
    });
  }
}
